import { useAppDispatch } from 'app/hooks'
import { getWidgetForDashboard } from 'features/widget/asyncThunks'
import { useDashboardData, useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { useEffect } from 'react'
import { Dashboard } from 'schemas/DashboardSchema'
import { createInsightCount } from 'utils/runSearchUtil'
import { toFilter } from 'utils/widgetUtil'
import { WidgetId } from 'features/types'
import { getInsightCategory } from 'utils/viewOptionUtil'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'
import { getMeasureByCountTypeAndAnalysisType } from 'utils/measureUtil'

import { TagsWidgetsType } from '../../types'

const createSearch = (widgetSetting: TagsWidgetsType, dashboardData: Dashboard) => {
  const { selectedTopic, countType, viewOption, precision, analysisType, level } = widgetSetting
  const filter = toFilter(widgetSetting)
  const topicIds = [selectedTopic.topicId!]
  const { id: dashboardId, name } = dashboardData
  const measure = getMeasureByCountTypeAndAnalysisType(countType!, analysisType!)
  const categories = getInsightCategory(viewOption!, analysisType)
  const DEFAULT_SIZE_NEEDED = 3000

  const insightCountOptions = {
    sizeNeeded: DEFAULT_SIZE_NEEDED,
    forceNotScale: true,
    ...(level && { facetServiceProperties: { level } })
  }

  return createInsightCount(
    dashboardId!,
    name!,
    precision!,
    topicIds,
    filter,
    measure!,
    categories,
    insightCountOptions
  )
}

const RunSearchEffect = ({
  widgetId,
  children
}: {
  widgetId: WidgetId
  children: React.ReactElement
}) => {
  const widgetSetting = useDashboardWidgetSetting<TagsWidgetsType>(widgetId)
  const dashboardData = useDashboardData()
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp(widgetId)

  useEffect(() => {
    const search = createSearch(widgetSetting, dashboardData!)

    dispatch(
      getWidgetForDashboard({
        searches: [search],
        widgetId: widgetSetting.widgetId!,
        timestamp: refreshTimestamp
      })
    )
  }, [widgetSetting, dashboardData, dispatch, refreshTimestamp])

  return children
}

export default RunSearchEffect
